import { computed } from "#imports";
const getTextColor = computed(() => {
  return (el) => {
    while (el) {
      if (el.tagName === "DIV" && el.id.includes("voix-slice")) {
        if (el.style.color) {
          return el.style.color;
        }
      }
      if (el.parentElement) {
        el = el.parentElement;
      } else {
        break;
      }
    }
    return "";
  };
});
const vVoixTextColor = {
  updated(el) {
    el.style.color = getTextColor.value(el);
  }
};
export default vVoixTextColor;
